(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('AdvertisingSourceDeleteController',AdvertisingSourceDeleteController);

    AdvertisingSourceDeleteController.$inject = ['$uibModalInstance', 'entity', 'AdvertisingSource'];

    function AdvertisingSourceDeleteController($uibModalInstance, entity, AdvertisingSource) {
        var vm = this;

        vm.advertisingSource = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            AdvertisingSource.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
